import { Branches } from "../types/branches";
import { httpRequest } from "./api";
import { LoginForm } from '../types/login';

const BRANCHES_URL = "branches";

export const GetBranchesAPI = async (): Promise<Branches[]> => {
    const response = await httpRequest<unknown, { payload: Branches[] }>({
        method: 'GET',
        url: BRANCHES_URL,
    });
    return response.payload;
}

export const UpdateBranchesAPI = async (branches: Branches[]): Promise<Branches[]> => {
    const response = await httpRequest<Branches[], Branches[]>({
        method: 'PUT',
        url: BRANCHES_URL,
        body: branches
    });
    return response;
}

export const userLogin = async (loginForm: LoginForm): Promise<{ token: string }> => {
    const response = await httpRequest<LoginForm, any>({
        method: "POST",
        url: "auth/login",
        body: {
            ...loginForm,
        },
    });
    return response;
}